export const CustomerType = {
  VMI: 1,
  MonthlyCapped: 2,
  WeeklyOrder: 3,
};